import React, { FC } from 'react';
import {
  ClickEventTags,
  useLoadLoggerForDataDog,
} from 'hooks/use-data-dog-logger';
import { useTranslation } from 'hooks/use-translation';
import { Button } from '../button';
import { ReactComponent as Google } from './google.svg';
import { ReactComponent as Microsoft } from './microsoft.svg';

// https://dev.to/mremanuel/add-the-new-google-sign-in-to-your-react-app-p6m
export const GoogleLogin: FC<{ href?: string; isLoading?: boolean }> = ({
  href,
  isLoading,
}) => {
  const googleLogin = useTranslation('google.sign-in');

  useLoadLoggerForDataDog([ClickEventTags.TimesheetCalendarDrawerOpen]);

  return (
    <Button
      icon={<Google />}
      iconPlacement="left"
      disabled={isLoading}
      loading={isLoading}
      onClick={() => {
        if (href) {
          window.location.href = href;
        }
      }}
    >
      {googleLogin}
    </Button>
  );
};

export const MicrosoftLogin: FC<{ href?: string; isLoading?: boolean }> = ({
  href,
  isLoading,
}) => {
  const login = useTranslation('microsoft.sign-in');

  useLoadLoggerForDataDog([ClickEventTags.TimesheetCalendarDrawerOpen]);

  return (
    <Button
      icon={<Microsoft />}
      iconPlacement="left"
      disabled={isLoading}
      loading={isLoading}
      onClick={() => {
        if (href) {
          window.location.href = href;
        }
      }}
    >
      {login}
    </Button>
  );
};
